import { render } from "./ProductCombinationsMobile.vue?vue&type=template&id=ff13c3c0"
import script from "./ProductCombinationsMobile.vue?vue&type=script&lang=js"
export * from "./ProductCombinationsMobile.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/brekz-prestashop/brekz-prestashop/web/themes/brekz-2017/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__